/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import DbBaseObject from "@shared/DbBaseObject";
import {
	GenogramConnectionCategoryEnum,
	normalizeGenogramConnectionCategory,
} from "@shared/Genogram/GenogramConnectionCategoryEnum";
import {
	GenogramCustomConnectionCenterSymbolEnum,
	GenogramCustomConnectionDecorationEnum,
	GenogramCustomConnectionDirectionEnum,
	GenogramCustomConnectionPatternEnum,
} from "@shared/Genogram/GenogramCustomConnectionEnum";

const DEFAULT_COLOR = "#D94841"

function normalizeSelectValue(value, fallback) {
	if(value != null && typeof value === "object" && value.value != null){
		return value.value
	}
	return value ?? fallback
}

function normalizeDecorationValue(value) {
	let normalizedValue = normalizeSelectValue(value, GenogramCustomConnectionDecorationEnum.NONE)
	switch (normalizedValue) {
		case "bar":
			return GenogramCustomConnectionDecorationEnum.PERPENDICULAR_TICKS
		case "doubleBar":
			return GenogramCustomConnectionDecorationEnum.DOUBLE_TICKS
		case "hooks":
			return GenogramCustomConnectionDecorationEnum.SLASHES
		case "fork":
			return GenogramCustomConnectionDecorationEnum.CROSS_TICKS
		case "endDot":
			return GenogramCustomConnectionDecorationEnum.DOTS_OVERLAY
		default:
			return normalizedValue
	}
}

export default class GenogramCustomConnectionItem extends DbBaseObject {

	title: string = ""
	isDeleted: boolean = false
	connectionCategory: string = GenogramConnectionCategoryEnum.EMOTIONAL
	renderConfig: Object = {
		color: DEFAULT_COLOR,
		lineCount: 1,
		pattern: GenogramCustomConnectionPatternEnum.SOLID,
		centerSymbol: GenogramCustomConnectionCenterSymbolEnum.NONE,
		decoration: GenogramCustomConnectionDecorationEnum.NONE,
		direction: GenogramCustomConnectionDirectionEnum.NONE,
	}

	getCurrentSchemaVersion() {
		return 1
	}

	normalize() {
		this.connectionCategory = normalizeGenogramConnectionCategory(this.connectionCategory)
		let renderConfig = this.renderConfig || {}
		this.renderConfig = {
			color: DEFAULT_COLOR,
			lineCount: Number(normalizeSelectValue(renderConfig.lineCount, 1)) || 1,
			pattern: normalizeSelectValue(renderConfig.pattern, GenogramCustomConnectionPatternEnum.SOLID),
			centerSymbol: normalizeSelectValue(renderConfig.centerSymbol, GenogramCustomConnectionCenterSymbolEnum.NONE),
			decoration: normalizeDecorationValue(renderConfig.decoration),
			direction: normalizeSelectValue(renderConfig.direction, GenogramCustomConnectionDirectionEnum.NONE),
			...renderConfig,
		}
		this.renderConfig.lineCount = Number(normalizeSelectValue(this.renderConfig.lineCount, 1)) || 1
		this.renderConfig.pattern = normalizeSelectValue(this.renderConfig.pattern, GenogramCustomConnectionPatternEnum.SOLID)
		this.renderConfig.centerSymbol = normalizeSelectValue(this.renderConfig.centerSymbol, GenogramCustomConnectionCenterSymbolEnum.NONE)
		this.renderConfig.decoration = normalizeDecorationValue(this.renderConfig.decoration)
		this.renderConfig.direction = normalizeSelectValue(this.renderConfig.direction, GenogramCustomConnectionDirectionEnum.NONE)
		if(this.connectionCategory === GenogramConnectionCategoryEnum.SOCIAL){
			this.renderConfig.direction = GenogramCustomConnectionDirectionEnum.NONE
		}
		this.title = (this.title || "").trim()
		return this
	}

	beforeSaveToDb(options = {}) {
		this.normalize()
		super.beforeSaveToDb(options)
	}
}
